jQuery(document).ready(function() {
    var $ = jQuery;
    var ratingsObject = {};
    function initReviewModal(button)
    {
        var postId = $(button).data('postid');

        var rating = 0;
        let starBtns = $(".star-rating > button");
        $(starBtns).addClass("empty").removeClass("full");

        if( postId in ratingsObject )
        {
            $("#userReviewText").val(ratingsObject[postId].comment);
            //rating = ratingsObject[postId].rating;
            $(starBtns[ratingsObject[postId].rating - 1]).click();
        }
        else
        {
            $("#userReviewText").val("");
        }

        let img = $(button).closest(".order-item").find('.item-image').first().attr('src');
        let snackName = $(button).closest(".order-item").find('.item-name').first().html();
        let altSnackName = snackName.replace('<br>', '');

        $("#review-item-image")
            .attr('src', img)
            .attr('alt', `Image of ${altSnackName}`);
        $("#review-item-name").html(snackName);

        $(starBtns).on('click', function(e){
            let star = e.currentTarget;
            let parent = star.parentNode;
            // The equivalent of parent.children.indexOf(child)
            rating = Array.prototype.indexOf.call(parent.children, star) + 1;

            $(star).parent().children().each( function(idx, elem) {
                if(idx < rating)
                {
                    $(elem).addClass('full').removeClass('empty');
                }
                else
                {
                    $(elem).removeClass('full').addClass('empty');
                }
            });
            
        });

        var allReviewButtons = $("[data-target='#reviewItemModal']").toArray();
        if( allReviewButtons.length == 1 )
        {
            $("#nextItem").attr('disabled', 'disabled')
                .addClass('d-none');
        }
        else
        {
            $("#nextItem").unbind('click');
            $("#nextItem").on('click', function(event){
                event.preventDefault();
                let idx = (Array.prototype.indexOf.call(allReviewButtons, button) + 1) % allReviewButtons.length;
                
                ratingsObject[postId] = {
                    'rating': rating,
                    'comment': $("#userReviewText").val()
                };

                initReviewModal(allReviewButtons[idx]);
            });
        }

        $("#saveReview").unbind('click');
        $("#saveReview").on('click', function(){
            ratingsObject[postId] = {
                'rating': rating,
                'comment': $("#userReviewText").val()
            };

            for (const [id, values] of Object.entries(ratingsObject)) 
            {
                if(values.rating == 0 && values.comment != '')
                {
                    jQuery('#alert-container').addClass('alert-danger').text( 'Must choose a rating from 1 to 5 stars.' ).show().delay(5000).fadeOut();
                }
                else if(values.rating > 0)
                {
                    $.ajax({
                        url: '/wp-admin/admin-ajax.php',
                        type: "POST",
                        beforeSend: function(xhr){
                            xhr.setRequestHeader('csrf_token', jQuery('meta[name="csrf-token"]').attr('content'));
                        },
                        data: {
                            'rating': values.rating,
                            'postId': id,
                            'comment': values.comment,
                            'action': 'sc_rate_snack',
                        },
                        dataType: 'json',
                        success: function(response) {
                            jQuery('#alert-container').removeClass('alert-danger').addClass('alert-success').text( 'Rating was saved successfully' ).show().delay(5000).fadeOut();
                            jQuery("a[data-postId='"+id+"']").remove();
                        },
                        error: function(error) {
                            console.error(error);
                        }
                    });
                }
            }
        });
    }

    $('#reviewItemModal').on('show.bs.modal', function (event) {
        initReviewModal(event.relatedTarget);
    });
});